/**
 * Vest NQ-PERP candle overlay on the CME price chart (MNQ/NQ): on / off.
 * Off by default; the small toggle on the price pane flips it and the choice
 * is kept per device (localStorage `vest-candle-overlay`). Drawing and the
 * rolling gap live in utils/vestCandles.ts and ChartView.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface VestCandleOverlayState {
  enabled: boolean;
  setEnabled: (v: boolean) => void;
  toggle: () => void;
}

/** Only an explicit `true` turns it on (missing / corrupt blobs stay off). */
export function mergeVestCandleOverlay(persisted: unknown): Pick<VestCandleOverlayState, 'enabled'> {
  const p = (persisted && typeof persisted === 'object' ? persisted : {}) as Record<string, unknown>;
  return { enabled: p.enabled === true };
}

export const useVestCandleOverlayStore = create<VestCandleOverlayState>()(
  persist(
    (set, get) => ({
      enabled: false,
      setEnabled: (v) => set({ enabled: v === true }),
      toggle: () => set({ enabled: !get().enabled }),
    }),
    {
      name: 'vest-candle-overlay',
      partialize: (s) => ({ enabled: s.enabled }),
      merge: (persisted, current) => ({ ...current, ...mergeVestCandleOverlay(persisted) }),
    },
  ),
);
